<div class="input-group field-input-group">
    <ycn-search-bar
        class="input-group field-input-group"
        [autocompleterId]="autocompleterId"
        [searchType]="searchType"
        [defaultOnly]="defaultOnly"
        (searchBlockHandler)="searchBlockHandler.emit($event)"
        [searchBlockRegex]="searchBlockRegex"
        [buttonText]="buttonText"
        [buttonType]="buttonType"
        [resultsType]="resultsType"
        [categoriesExtraLinks]="resultsExtraLinks"
        (backspaceHandler)="backspaceHandler.emit()"
        (browseClickHandler)="browseClickHandler.emit()"
        (searchBarBlurHandler)="searchBarBlurHandler.emit($event)"
        [placeholder]="placeholder"
        [includeSearchIcon] = "includeSearchIcon"
        [inputAutocomplete]="inputAutocomplete()"
        [isDisabled]="isDisabled"
        [isInvalid]="isInvalid"
        [hideButton]="hideButton"
        [searchableSecurityIds]="searchableSecurityIds"
    ></ycn-search-bar>
    <!-- For the below 2 components, must use [hidden] instead of *ngIf to work with ycnAppendToBody-->
    <ycn-list-results
        class="dropdown-menu"
        [ycnAppendToBody]="appendToBody"
        [ycnAppendToBodyPosition]="appendToBodyPosition()"
        [hidden]="resultsType !== 'list'"
        [ngClass]="{ show: showResults || (listFooterTemplate && hasInputFocus && inputText.trim()) }"
        [autocompleterId]="autocompleterId"
        [showMoreResultsUrl]="showMoreResultsUrl"
        [searchType]="searchType"
        [footerTemplate]="listFooterTemplate"
    ></ycn-list-results>
    <ycn-categories-results
        class="dropdown-menu"
        [dropdownMenuClass]="dropdownMenuClass"
        [ycnAppendToBody]="appendToBody"
        [ycnAppendToBodyPosition]="appendToBodyPosition()"
        [hidden]="resultsType !== 'categories'"
        [globalSearch]="globalSearch"
        [ngClass]="{ show: (showResults || (hasInputFocus && defaultResults.length > 0)), 'header-search-dropdown': hasFixedWidth  }"
        [autocompleterId]="autocompleterId"
        [showMoreResultsUrl]="showMoreResultsUrl"
    ></ycn-categories-results>
</div>

<ycn-feature-needed></ycn-feature-needed>
